<script>
import { toDecPercent } from '@utils/Format'
import {
  calculateLineYAxisLimits,
  getChartOptions,
} from '@modules/comissoes/utils/chartUtils'
import ChartjsLegend from '@modules/global/components/charts/chartjs-legend.vue'

export default {
  name: 'RentabilidadeChart',
  components: {
    ChartjsLegend,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      hiddenOptions: {},
    }
  },
  computed: {
    formattedChartData() {
      if (!this.data || !this.data.labels || !this.data.datasets) {
        return {
          labels: [],
          datasets: (this.data && this.data.datasets) || [],
        }
      }

      const formattedData = JSON.parse(JSON.stringify(this.data))

      formattedData.labels = formattedData.labels.map((label) => {
        const [day, month, year] = label.split('/')
        return `${day}/${month}/${year.slice(-2)}`
      })

      formattedData.datasets = formattedData.datasets.map((item) => {
        return {
          ...item,
          hidden: this.hiddenOptions[item.label] || false,
        }
      })

      return formattedData
    },
    chartOptions() {
      return getChartOptions(this.chartLineOptions, this.yAxisLimits, (v) =>
        toDecPercent(v)
      )
    },
    chartLineOptions() {
      return {
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: (item, data) => {
              let label = data.datasets[item.datasetIndex].label || ''
              label += ': ' + toDecPercent(item.yLabel)
              return label
            },
            title: (item, data) => {
              return item[0].xLabel || ''
            },
          },
        },
        hover: {
          mode: 'index',
          intersect: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontSize: 10,
                callback: (v, i, vs) => {
                  return toDecPercent(v)
                },
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          point: {
            radius: 0,
            borderWidth: 0,
          },
          line: {
            borderWidth: 0,
          },
        },
        legend: {
          display: false,
        },
      }
    },
    yAxisLimits() {
      const acceptValuesNegative = true

      return calculateLineYAxisLimits(
        this.formattedChartData.datasets,
        acceptValuesNegative
      )
    },
  },
  methods: {
    toggleDatasetVisibility(label) {
      this.$set(this.hiddenOptions, label, !this.hiddenOptions[label])
    },
  },
}
</script>

<template>
  <div class="rentabilidade-chart">
    <line-chart :chart-data="formattedChartData" :options="chartOptions" />
    <ChartjsLegend
      :datasets="formattedChartData.datasets"
      :on-toggle="toggleDatasetVisibility"
      class="rentabilidade-chart__legend"
    />
  </div>
</template>

<style lang="sass">
@import '@modules/consolidator/design/componentes/chartjs-legend.sass'

.rentabilidade-chart
  &__legend
    @extend .chartjs-legend
</style>
